import React, { useCallback, useState } from "react";

import {
  SizeAndFitSheet,
  type SizeAndFitButtonProps,
} from "~/templates/product/SizeAndFitSheet";

import { Button, IconMeasuringTape } from "@bared/ui";

export function SizeButton({
  gender,
  isFitKitIncluded,
}: SizeAndFitButtonProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSheetToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [isOpen]);

  return (
    <>
      <div>
        <Button
          variant="link"
          size="medium"
          onClick={handleSheetToggle}
          className="flex items-baseline font-medium"
        >
          <IconMeasuringTape className="w-mini" />
          Size & Fit Guide
        </Button>
      </div>

      <SizeAndFitSheet
        activeTab="sizeGuide"
        isOpen={isOpen}
        handleSheetToggle={handleSheetToggle}
        gender={gender}
        isFitKitIncluded={isFitKitIncluded}
      />
    </>
  );
}
